export default {
    // columnas que contiene la tabla
    columns: {
        type: Array,
        required: true
    },
    // filas seleccionadas por el usuario
    // este array puede estar vacío, por lo que se exportaría toda la info
    rows: {
        type: Array
    },
    sort: {
        type: String
    }
};
